import { render, staticRenderFns } from "./PhClipboardText.vue?vue&type=template&id=9d4690a4"
import script from "./PhClipboardText.vue?vue&type=script&lang=js"
export * from "./PhClipboardText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports